import React from "react"
import { useTranslation } from "react-i18next"

import ProtectedLayout from "layouts/Protected"
import { FormSearchBike, FormAdvancedSearchBike, BikePortability } from "./Partials"
import { BikeIcon } from "components/Elements/Icons"

import { useAuth, useBikeStore } from "hooks"
import { ADMIN_GENDERS_LIST } from "utils/constants"

export const HOME_SEARCH = "HOME_SEARCH"

export const SearchBikePage = () => {
    const {
        currentBike,
        resetBikeStoreInfo
    } = useBikeStore()

    const [bikeAvailableForPortability, setBikeAvailableForPortability] = React.useState(null)

    React.useEffect(() => {
        // We reset all data in Bike's context before a search
        if (currentBike) {
            resetBikeStoreInfo()
        }
    }, [currentBike]) // eslint-disable-line

    const { t } = useTranslation()
    const { entity, user } = useAuth()
    const entityRole = entity?.entity_data?.entity_permission?.role

    const isMANAGEENTITIES = entityRole === "MANAGEENTITIES"
    const isAdminUser = ADMIN_GENDERS_LIST.includes(user?.gender)

    const isFormAdvancedSearchBikeDisplayed = isMANAGEENTITIES && isAdminUser

    return (
        <ProtectedLayout className="px-5 py-7 lg:py-24">
            <div className="l-container">
                <div className="c-section-title mb-12">
                    <div className="c-section-title__content">
                        <BikeIcon size={40} />
                        <h1 className="c-section-title__title c-h2 text-primary font-medium ml-5">
                            {t(isMANAGEENTITIES ? "menu.search_bike" : "menu.activate_bike")}
                        </h1>
                    </div>
                </div>

                <div className="c-card p-5 lg:px-12 lg:py-7">
                    <FormSearchBike isAdmin={isMANAGEENTITIES} context={HOME_SEARCH} setBikeAvailableForPortability={setBikeAvailableForPortability} />
                </div>
                {bikeAvailableForPortability && <BikePortability bikeAvailableForPortability={bikeAvailableForPortability} />}
                {isFormAdvancedSearchBikeDisplayed && <div className="c-card p-5 lg:px-12 mt-7 lg:py-7">
                    <FormAdvancedSearchBike />
                </div>}
            </div>
        </ProtectedLayout>
    )
}
